import { Helmet } from "react-helmet";
import Section1 from "./Sections/Section1";
import Section2 from "./Sections/Section2";

export default function AboutUs() {
  return (
    <>
      <Helmet>
        <title>
          Get Server, PC and Networking Products at TechMatter | About
        </title>
        <meta
          name="description"
          content="Discover top-quality IT hardware solutions at unbeatable prices. From high-performance servers and custom-built PCs to routers, switches, and components — TechMatter is your trusted partner for business-grade technology across the UK and Europe."
        />
        <link rel="canonical" href="https://techmatter.co.uk/about" />
      </Helmet>
      <Section1 />
      <Section2 />
    </>
  );
}
